import React, { useEffect, useState } from 'react';
import SettingsSideBar from './components/settingsSideBar';
import './settings.scss';
import ProfileSettings from './organization/profile/profileSettings';
import Branding from './organization/branding/branding';
import Currencies from './organization/currencies/currencies';
import TaxSection from './organization/tax/taxSection';
import Products from './inventory/products';
import SettingsInventoryPackaging from './inventory/packagings';
import MeasuringUnit from './inventory/measuringUnit';
import SalesOrder from './sales/salesOrder';
import Packages from './sales/packages';
import Shipment from './sales/shipment';
import DeliveryChallans from './sales/deliveryChallans';
import SettingsInvoices from './sales/invoices';
import SettingsPaymentReceived from './sales/paymentReceived';
import SettingsSalesReturn from './sales/SalesReturn';
import SettingsCreditNote from './sales/creditNote';
import { useParams } from 'react-router-dom';
import { formatTitle } from '../../../utils/utility';
import PreferencesGeneral from './preferences/general';
import SettingsUsers from './users_and_roles/users';
import SettingsRoles from './users_and_roles/roles';
import SettingsPurchaseOrder from './purchases/purchase_order';
import SettingsPurchaseBills from './purchases/bills';
import SettingsPaymentsMade from './purchases/payments_made';
import SettingsPurchaseReceive from './purchases/purchase_receive';
import SettingsVendorCredit from './purchases/vendor_credit';
export default function Settings() {
	const [activeTab, setActiveTab] = useState('Profile Settings');
	const [activeType, setActiveType] = useState('profile-settings');
	const param = useParams();
	const type = param?.type;

	function getActiveType() {
		if (type) {
			setActiveType(type);
			setActiveTab(formatTitle(type));
		}
	}

	useEffect(() => {
		getActiveType();
	}, [activeTab]);

	return (
		<div className="">
			{/* Sidebar */}
			<SettingsSideBar
				activeTab={activeTab}
				setActiveTab={setActiveTab}
			/>
			<div className="p-8 settings-section">
				{activeType === 'profile-settings' ? (
					<ProfileSettings activeTab={activeTab} />
				) : activeType === 'branding' ? (
					<Branding activeTab={activeTab} />
				) : activeType === 'currencies' ? (
					<Currencies activeTab={activeTab} />
				) : activeType === 'tax' ? (
					<TaxSection activeTab={activeTab} />
				) : activeType === 'general' ? (
					<PreferencesGeneral activeTab={activeTab} />
				) : activeType === 'products' ? (
					<Products activeTab={activeTab} />
				) : activeType === 'packaging' ? (
					<SettingsInventoryPackaging activeTab={activeTab} />
				) : activeType === 'measuring-unit' ? (
					<MeasuringUnit activeTab={activeTab} />
				) : activeType === 'sales-order' ? (
					<SalesOrder activeTab={activeTab} />
				) : activeType === 'packages' ? (
					<Packages activeTab={activeTab} />
				) : activeType === 'shipment' ? (
					<Shipment activeTab={activeTab} />
				) : activeType === 'delivery-challans' ? (
					<DeliveryChallans activeTab={activeTab} />
				) : activeType === 'invoices' ? (
					<SettingsInvoices activeTab={activeTab} />
				) : activeType === 'payments-received' ? (
					<SettingsPaymentReceived activeTab={activeTab} />
				) : activeType === 'sales-return' ? (
					<SettingsSalesReturn activeTab={activeTab} />
				) : activeType === 'credit-note' ? (
					<SettingsCreditNote activeTab={activeTab} />
				) : activeType === 'users' ? (
					<SettingsUsers activeTab={activeTab} />
				) : activeType === 'roles' ? (
					<SettingsRoles activeTab={activeTab} />
				) : activeType === 'bills' ? (
					<SettingsPurchaseBills activeTab={activeTab} />
				) : activeType === 'payments-made' ? (
					<SettingsPaymentsMade activeTab={activeTab} />
				) : activeType === 'purchase-orders' ? (
					<SettingsPurchaseOrder activeTab={activeTab} />
				) : activeType === 'purchase-receive' ? (
					<SettingsPurchaseReceive activeTab={activeTab} />
				) : activeType === 'vendor-credit' ? (
					<SettingsVendorCredit activeTab={activeTab} />
				) : (
					''
				)}
			</div>
		</div>
	);
}
